import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { NEWS_COLORS } from "../constants/news.constants";
import { pmArticle } from "../data/newsContent";
import { ROUTE_PATHS } from "@/routes/routePaths";
import { NewsMeta, NewsTag } from "./NewsTag";
import { NewsVideoCard } from "./NewsVideoCard";

export function NewsArticlePm() {
  const a = pmArticle;

  return (
    <article id={a.id} className="scroll-mt-24 border-t border-gray-100 pt-12 sm:pt-16">
      <div className="grid gap-8 lg:grid-cols-[1.15fr_0.85fr] lg:items-start lg:gap-10">
        <div>
          <div className="flex flex-wrap items-center gap-3">
            <NewsTag>{a.tag}</NewsTag>
            <NewsMeta date={a.date} readTime={a.readTime} />
          </div>
          <h2 className="mt-4 text-2xl font-extrabold leading-snug tracking-tight text-gray-900 sm:text-3xl">
            {a.title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-gray-600 sm:text-base">
            {a.description}
          </p>
          <Link
            to={ROUTE_PATHS.ABOUT_DURI}
            className="mt-6 inline-flex items-center gap-2 rounded-full border-2 px-5 py-2.5 text-sm font-semibold transition-colors hover:bg-[#E8F5F0]"
            style={{
              borderColor: NEWS_COLORS.primary,
              color: NEWS_COLORS.primary,
            }}
          >
            Read More
            <ArrowRight className="h-4 w-4" aria-hidden />
          </Link>
        </div>

        <NewsVideoCard duration={a.videoDuration} tone="national" />
      </div>

      <div
        className="mt-8 rounded-2xl p-5 sm:p-6"
        style={{ backgroundColor: NEWS_COLORS.surface }}
      >
        <p
          className="text-xs font-semibold uppercase tracking-wide"
          style={{ color: NEWS_COLORS.primary }}
        >
          {a.keyMessagesHeading}
        </p>
        <ul className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {a.keyMessages.map(({ title, description, Icon }) => (
            <li key={title} className="flex flex-col items-start gap-2 sm:items-center sm:text-center">
              <span
                className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow-sm"
                style={{ color: NEWS_COLORS.primary }}
              >
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <p className="text-sm font-bold text-gray-900">{title}</p>
              <p className="text-xs leading-snug text-gray-500">{description}</p>
            </li>
          ))}
        </ul>
      </div>
    </article>
  );
}
